Shopify.theme.infiniteScroll = {
    init: function init() {
        this.defaults = {
            grid: '[data-load-more--grid]',
            gridItems: '[data-load-more--grid-item]'
        };
        $('[data-load-more]').on('click', function (e) {
            e.preventDefault();
            var $button = $(this);
            var url = $button.attr('href');
            Shopify.theme.infiniteScroll.loadNextPage(url, $button);
        });
        $('[data-load-more-infinite]').on('click', function (e) {
            Shopify.theme.infiniteScroll.enableInfinite();
            $(this).remove(); // Prevent link from going to next page

            e.stopPropagation();
            return false;
        });

        if ($('[data-load-infinite-scroll]').length) {
            Shopify.theme.infiniteScroll.enableInfinite();
        }
    },
    loadNextPage: function loadNextPage(url, $button) {
        var _this = this;

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: url,
            beforeSend: function beforeSend() {
                $button.addClass('is-loading');
            },
            success: function success(data) {
                $button.removeClass('is-loading');
                var thumbnails = $(data).find(_this.defaults.gridItems);
                var loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
                $('[data-load-more]').attr('href', loadMoreButtonUrl);
                $(_this.defaults.grid).first().append(thumbnails); // When there are no additional pages, hide load more button

                if (typeof loadMoreButtonUrl == 'undefined') {
                    $('[data-load-more]').addClass('is-hidden');
                }
            },
            error: function error(x, t, m) {
                console.log(x);
                console.log(t);
                console.log(m);
                location.replace(location.protocol + '//' + location.host + filterURL);
            }
        });
    },
    enableInfinite: function enableInfinite() {
        var infiniteScroll = new Waypoint.Infinite({
            element: $(this.defaults.grid)[0],
            items: '[data-load-more--grid-item]',
            more: '[data-load-infinite]',
            loadingClass: 'loading-in-progress',
            onBeforePageLoad: function onBeforePageLoad() {
                $('[data-load-infinite]').removeClass('is-hidden');
            },
            onAfterPageLoad: function onAfterPageLoad(data) {}
        });
    },
    unload: function unload() {
        $('[data-load-more]').off();
        $('[data-load-infinite]').off();
    }
};
if ($('[data-custom-pagination]').length) {
    Shopify.theme.infiniteScroll.init();
}
